import React from 'react'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { GetFeatureAvailabilitiesDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

interface WithFeatureFlagProps {
  children: (loading: boolean) => JSX.Element
  features: Features[]
  allowWhileLoading?: boolean
  fallback?: (() => React.ReactNode) | React.ReactNode
}

const WithPaywall: React.FC<WithFeatureFlagProps> = ({
  children,
  features,
  allowWhileLoading = false,
  fallback,
}) => {
  const { company } = useCurrentSession()
  const { data } = useQuery(GetFeatureAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      modules: [AvailableModules.finance],
      companyId: company.id,
      ids: features,
    },
  })

  if (!data) {
    if (allowWhileLoading) {
      return children(true)
    } else {
      return <div data-testid="loading"></div>
    }
  }

  const paywallEnabled = features
    .map((f) => isFeatureAvailabilityEnabled(data.companies.featureAvailabilities, f))
    .every((r) => r === true)

  return paywallEnabled ? (
    <>{children(false)}</>
  ) : fallback ? (
    <>{typeof fallback === 'function' ? fallback() : fallback}</>
  ) : (
    <NotFound />
  )
}

export default WithPaywall
